import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

function useCurrentUrl() {
  const route = useRoute();
  const currentUrl = ref('');

  if (typeof window !== 'undefined') {
    currentUrl.value = window.location.origin + route.fullPath;
  }

  watch(
    () => route.fullPath,
    (newPath) => {
      if (typeof window !== 'undefined') {
        currentUrl.value = window.location.origin + newPath;
      }
    },
  );

  return { currentUrl };
}

export default useCurrentUrl;
